export const godziny = [
    {
        id: 1,
        day: 'PN',
        godzinaOd: '7:00',
        godzinaDo: '17:00',
    },
    {
        id: 2,
        day: 'WT',
        godzinaOd: '7:00',
        godzinaDo: '17:00',
    },
]

export const footer =
{
    ulica: 'Nazwa Ulicy',
    nrBud: '12/34',
    kod: '12-123',
    miasto: 'Nazwa miasta',
    woj: 'Śląskie',
    kraj: 'Polska',
    tel: '123 456 789',
    mail: 'mail.dlugimail@mail.com',
}

export const kontakt =
{
    ulica: 'Nazwa Ulicy',
    nrBud: '12/34',
    kod: '12-123',
    miasto: 'Nazwa miasta',
    woj: 'Śląskie',
    kraj: 'Polska',
    tel: '123 456 789',
    mail: 'mail.dlugimail@mail.com',
}

export const info =
{
    ulica: 'Nazwa Ulicy',
    nrBud: '12/34',
    kod: '12-123',
    miasto: 'Nazwa miasta',
    woj: 'Śląskie',
    kraj: 'Polska',
    tel: '123 456 789',
    mail: 'mail.dlugimail@mail.com',
}